import {Column, Table} from '@tanstack/react-table'
import {Selection} from '../Selection'
import {useAppDispatch, useAppSelector} from '../../redux/hooks'
import {filterSelector, setFilterContracts} from '../../redux/slices/filterSlices'
import {CONTRACT_STATUS, PAYMENT_TYPE, PRODUCT_TYPE} from '../../constants'
import {t} from 'i18next'
import {TextInputV2} from '../TextInputV2'
import {IOrder} from './types'
import DatePickerV2 from '../DatePickerV2/DatePickerV2'

export function Filter({column, table}: {column: Column<IOrder, any>; table: Table<IOrder>}) {
  const columnFilterValue = column.getFilterValue()
  const {filterContracts: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const handleChange = (value: Partial<typeof filter>) => {
    dispatch(setFilterContracts({...filter, ...value}))
  }

  if (column.id === 'validity_date_to') {
    return (
      <DatePickerV2
        placeholder={t('End-Date')}
        isSelectsRange={false}
        startDate={filter?.validity_date_to ?? ''}
        onChange={({startDate}) => handleChange({validity_date_to: startDate.replaceAll('/', '-')})}
      />
    )
  }

  if (column.id === 'product_types') {
    return (
      <Selection
        formSelectProps={{style: {padding: '10px 0.5rem', border: 0}}}
        placeholder={t('sub-order-jenis')}
        data={PRODUCT_TYPE}
        value={filter?.product_type ?? ''}
        onChange={(product_type) => handleChange({product_type})}
      />
    )
  }

  if (column.id === 'total_quantum') {
    return (
      <TextInputV2
        style={{padding: '0 0.5rem', border: 0}}
        placeholder={t('kontrak-kuantum')}
        value={filter?.total_quantum ?? ''}
        onChange={({target}) => handleChange({total_quantum: target.value})}
      />
    )
  }

  if (column.id === 'grand_total') {
    return (
      <TextInputV2
        style={{padding: '0 0.5rem', border: 0}}
        placeholder={t('kontrak-harga')}
        value={filter?.grand_total ?? ''}
        onChange={({target}) => handleChange({grand_total: target.value})}
      />
    )
  }

  if (column.id === 'payment_methods') {
    return (
      <Selection
        formSelectProps={{style: {padding: '10px 0.5rem', border: 0}}}
        placeholder={t('Metode Pembayaran')}
        data={PAYMENT_TYPE}
        value={(filter?.payment_type ?? '') as string}
        onChange={(payment_type) => handleChange({payment_type})}
      />
    )
  }

  if (column.id === 'status_text') {
    return (
      <Selection
        formSelectProps={{style: {padding: '10px 0.5rem', border: 0}}}
        placeholder={t('Status')}
        data={CONTRACT_STATUS}
        value={(filter?.status ?? '') as string}
        onChange={(value: any) => handleChange({status: value})}
      />
    )
  }

  return (
    <TextInputV2
      style={{padding: '0 0.5rem', border: 0}}
      value={(columnFilterValue ?? '') as string}
      onChange={(e: any) => column.setFilterValue(e.target.value)}
      placeholder={`Search...`}
    />
  )
}
